export type RefreshResponse = {
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
};

export function isRefreshResponse(obj: any): obj is RefreshResponse {
  return 'accessToken' in obj && 'refreshToken' in obj && 'expiresIn' in obj;
}